/**
 * @license
 * Copyright (c) 2017, Barclays Africa Technology, All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file
 */

import { Observable } from 'rxjs/Observable';
import { Action } from '@ngrx/store';

import * as user from '../actions/user.actions';
import { User } from '@api/models/user';

/**
 * User state
 */
export interface UserState {
  user: User;
  isAuthenticated: boolean;
};

/**
 * User default state
 */
export const initialState: UserState = {
  user: null,
  isAuthenticated: false
};

/**
 * The 'user' reducer
 * @param state The current state
 * @param action The action we use to change the state
 * @return The new instance of UserState 
 */
export function reducer (state = initialState, action: Action): UserState {
    switch (action.type) {
        
        case user.LOGOFF_SUCCESS:
            return { 
                user: null,
                isAuthenticated: false
            };

        case user.LOGIN_SUCCESS:
            return { 
                user: action.payload,
                isAuthenticated: true 
            };

        default:
            return state;
    }
}

/**
 * Because the data structure is defined within the reducer it is optimal to
 * locate our selector functions at this level. If store is to be thought of
 * as a database, and reducers the tables, selectors can be considered the
 * queries into said database. Remember to keep your selectors small and
 * focused so they can be combined and composed to fit each particular
 * use-case.
 */

export const getUser = (state: UserState) => state.user;
export const getIsAuthenticated = (state: UserState) => state.isAuthenticated;



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/store/reducers/user.reducer.ts